import React, { FunctionComponent } from "react";
import styled from "styled-components";

interface PoliciesLayoutProps {
  children: React.ReactNode;
}

const PageLayout: FunctionComponent<PoliciesLayoutProps> = (props) => {
  return (
    <S.Container>
      <S.ContentWrap {...props}></S.ContentWrap>
    </S.Container>
  );
};

const S = () => {};

S.Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

S.ContentWrap = styled.div`
  max-width: 1440px;
  margin: 0 10vw;
  margin-top: 7.5rem;
  display: flex;
  flex-direction: column;
`;

export default PageLayout;
